import { render, staticRenderFns } from "./SidebarIcon.vue?vue&type=template&id=d3eceac6"
import script from "./SidebarIcon.vue?vue&type=script&lang=js"
export * from "./SidebarIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports